export enum EnumGrupoDocumento {
  SPLG = 1,
  ProvisionInformacion = 2,
  REMIT = 3,
  InformesRegulatorios = 4,
  DescargaPlantillas = 5,
  PrevisionDemanda = 6,
  Switching = 7,
  InformesRegulatoriosPower = 8,
  IIRRCNMCPower = 9,
  IIRRCNMCGas = 10,
  IIRRCORESGas = 11,
  DocumentosAdjuntosGas = 12,
  DocumentosAdjuntosElectricidad = 13,
  PerfilesConsumo = 14,
  DocumentosAtlas = 15
}
